import React from 'react';
import classNames from 'classnames';

import { Icon } from 'js/components';
import { faCheck, faForward } from '@fortawesome/pro-solid-svg-icons';

import styles from './Onboarding.module.scss';

/**
 * The circle in front of a step: a check when done, a skip arrow when skipped,
 * otherwise the step's number (highlighted when it's next).
 */
export function StepMarker({ step, small }) {
  const className = classNames(styles.marker, {
    [styles['marker-small']]: small,
  });

  if (step.status === 'done') {
    return (
      <span className={classNames(className, styles['marker-done'])}>
        <Icon icon={faCheck} />
        <span className="sr-only">Done</span>
      </span>
    );
  }

  if (step.status === 'skipped') {
    return (
      <span className={classNames(className, styles['marker-skipped'])}>
        <Icon icon={faForward} />
        <span className="sr-only">Skipped</span>
      </span>
    );
  }

  return (
    <span
      className={classNames(className, {
        [styles['marker-next']]: step.isNext,
      })}
    >
      {step.number}
    </span>
  );
}

/**
 * A step's title, muted once it's done or skipped.
 */
export function StepTitle({ step, className }) {
  return (
    <span
      className={classNames('font-weight-bold', className, {
        'text-muted': step.status !== 'todo',
      })}
    >
      {step.title}
    </span>
  );
}
